import { apiClient } from '../../shared/api/apiClient';
import { uploadFile } from '../../shared/api/uploadFile';
import {
    GetSpaceStatsResponseSchema, GetSpaceActivityResponseSchema, ListSpaceMembersResponseSchema,
    FetchAllUsersResponseSchema, UpdateSpaceResponseSchema, RemoveMemberResponseSchema,
    GetUserResponseSchema, CreateSpaceDefaultDocResponseSchema,
} from './schemas';

export const spacesApi = {
    fetchStats: async (spaceId) => {
        const json = await apiClient.get(`/api/space/${spaceId}/stats`).then((d) => GetSpaceStatsResponseSchema.parse(d));
        return json.success ? json.stats : { tasks: 0, docs: 0 };
    },
    fetchActivity: async (spaceId) => {
        const json = await apiClient.get(`/api/space/${spaceId}/activity`).then((d) => GetSpaceActivityResponseSchema.parse(d));
        return json.success ? (json.notifications || []) : [];
    },
    fetchMembers: async (spaceId) => {
        const json = await apiClient.get(`/api/space/${spaceId}/members`).then((d) => ListSpaceMembersResponseSchema.parse(d));
        return json.success ? json.members : [];
    },
    fetchAllUsers: () => apiClient.get('/api/users').then((d) => FetchAllUsersResponseSchema.parse(d)),
    update: (id, payload) => {
        const backendPayload = { ...payload };
        if (payload.name !== undefined) backendPayload.space_name = payload.name;
        if (payload.icon !== undefined) backendPayload['link-icon-space'] = payload.icon;
        return apiClient.put(`/api/space/${id}`, backendPayload).then((d) => UpdateSpaceResponseSchema.parse(d));
    },
    uploadLogo: (file) => uploadFile(file, 'space_icon'),
    removeMember: (spaceId, userId) => apiClient.del(`/api/space/${spaceId}/members/${userId}`).then((d) => RemoveMemberResponseSchema.parse(d)),
    fetchUserProfile: async (userId) => {
        const json = await apiClient.get(`/api/users/${userId}`).then((d) => GetUserResponseSchema.parse(d));
        return json.success ? json.user : null;
    },
    // Movidos desde ComponentSpaceDashboard.jsx (02.8-spaces-mail-shell.md §4) -- vivían como
    // `fetch()` crudos inline. `apiClient` manda `credentials: 'include'` (sesión vía cookie);
    // el `fetch` original de `suspendMember` no mandaba ni eso ni un header de auth -- en dev
    // (frontend/backend en orígenes distintos) probablemente fallaba la autenticación
    // silenciosamente. El de `createDefaultDoc` sí mandaba un `Authorization: Bearer` manual
    // (inconsistente con el resto del proyecto, que usa cookie de sesión) -- se retira, `apiClient`
    // ya cubre la sesión.
    suspendMember: (userId) => apiClient.put(`/api/users/${userId}`, { welcome: 3 }).then((d) => GetUserResponseSchema.parse(d)),
    createDefaultDoc: async (spaceId) => {
        const json = await apiClient.post(`/api/space/${spaceId}/default-doc`).then((d) => CreateSpaceDefaultDocResponseSchema.parse(d));
        return json.success ? json.docId : null;
    },
    createAgent: (spaceId, payload) => apiClient.post(`/api/space/${spaceId}/agent`, payload),
};
